package ui.app.assign.detail.wheel.editor.widgets

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Card
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Slider
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.StringResource
import tools.EFieldDualIntAsFloat
import tools.rememberString
import ui.app.assign.detail.wheel.editor.AppEditorWheelScope

@Composable
fun AppEditorWheelScope.FieldSlider(
    label: StringResource,
    field: EFieldDualIntAsFloat,
    canEdit: Boolean = true,
    modifier: Modifier = Modifier
) {
    Card(modifier) {
        Text(
            text = label.rememberString(),
            style = MaterialTheme.typography.labelLarge,
            modifier = Modifier.padding(vertical = 8.dp)
                .padding(horizontal = 16.dp)
        )
        Slider(
            value = field.state,
            enabled = canEdit,
            valueRange = 0.01f..1f,
            modifier = Modifier.fillMaxWidth()
                .padding(horizontal = 16.dp),
            onValueChange = {
                field.set(it)
            })
    }
}